import { Injectable } from '@angular/core';
import { Settings, SettingsData, SettingsService, SettingsStorage } from '@next/core-lib/settings';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { LayerContextKeys } from '../constants';

@Injectable()
export class SettingsServiceHelper {
  constructor(private settingsService: SettingsService) {}

  removeSettings(
    key: string,
    storage: SettingsStorage = SettingsStorage.AppLocal,
    basedOnProfile = false,
    basedOnCustomer = false,
    basedOnLocation = false,
    context: string = LayerContextKeys.POULTRYNEXTLAYER,
  ) {
    this.settingsService
      .removeSettings({
        contextName: context,
        key,
        storage,
        basedOnCurrentProfile: basedOnProfile,
        basedOnCurrentCustomer: basedOnCustomer,
        basedOnCurrentLocation: basedOnLocation,
      })
      .subscribe();
  }

  getSettings(
    key: string,
    storage: SettingsStorage = SettingsStorage.AppLocal,
    basedOnProfile = false,
    basedOnCustomer = false,
    basedOnLocation = false,
    context: string = LayerContextKeys.POULTRYNEXTLAYER,
  ): Observable<Settings[]> {
    return this.settingsService.getSettings({
      contextName: context,
      key,
      storage,
      basedOnCurrentProfile: basedOnProfile,
      basedOnCurrentCustomer: basedOnCustomer,
      basedOnCurrentLocation: basedOnLocation,
    });
  }

  getSingle<T>(
    defaultValue: T,
    key: string,
    storage: SettingsStorage = SettingsStorage.AppLocal,
    basedOnProfile = false,
    basedOnCustomer = false,
    basedOnLocation = false,
    context: string = LayerContextKeys.POULTRYNEXTLAYER,
  ): Observable<T> {
    return this.settingsService.getSingle<T>(
      {
        contextName: context,
        key,
        storage,
        basedOnCurrentProfile: basedOnProfile,
        basedOnCurrentCustomer: basedOnCustomer,
        basedOnCurrentLocation: basedOnLocation,
      },
      defaultValue,
    );
  }

  setSettings(
    key: string,
    data: SettingsData,
    storage: SettingsStorage = SettingsStorage.AppLocal,
    basedOnProfile = false,
    basedOnCustomer = false,
    basedOnLocation = false,
    context: string = LayerContextKeys.POULTRYNEXTLAYER,
  ) {
    this.settingsService
      .setSettings({
        contextName: context,
        key,
        storage,
        basedOnCurrentProfile: basedOnProfile,
        basedOnCurrentCustomer: basedOnCustomer,
        basedOnCurrentLocation: basedOnLocation,
        data,
      })
      .subscribe();
  }

  setSettingsAndGetId(
    key: string,
    data: SettingsData,
    storage: SettingsStorage = SettingsStorage.AppLocal,
    basedOnProfile = false,
    basedOnCustomer = false,
    basedOnLocation = false,
    context: string = LayerContextKeys.POULTRYNEXTLAYER,
  ): Observable<string | number> {
    return this.settingsService
      .setSettings({
        contextName: context,
        key,
        storage,
        basedOnCurrentProfile: basedOnProfile,
        basedOnCurrentCustomer: basedOnCustomer,
        basedOnCurrentLocation: basedOnLocation,
        data,
      })
      .pipe(map((s) => s.settingsId));
  }
}
